document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".sc_home_hero .shop_btn, .rich-text__buttons .button, .sc-health-benefit .health_content .btn-health, .sc_easy_use .sec_content .product-btn").forEach(function(button) {
        button.addEventListener("click", function(e) {
            var href = this.getAttribute("href");
            console.log(href);

            if (href && href.charAt(0) === "#") {
                e.preventDefault();
                e.stopPropagation();

                var cleanHref = href.substring(1); // Remove "#"
                console.log(cleanHref + "aa");

                var target = document.querySelector('.featured-product[id="' + cleanHref + '"]');
                if (target) {
                    var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                    var offset = 120; // Offset from top

                    window.scrollTo({
                        top: targetPosition - offset,
                        behavior: "smooth"
                    });
                } else {
                    var target = document.querySelector('div[id="' + cleanHref + '"]');
                    var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                    var offset = 80; // Offset from top

                    window.scrollTo({
                        top: targetPosition - offset,
                        behavior: "smooth"
                    });
                }
            }
        });
    });
});